module.exports = __webpack_public_path__ + "static/media/0237_Medium.eb78c6b8.jpg";